import { render, staticRenderFns } from "./trees.vue?vue&type=template&id=038e1f52&scoped=true"
import script from "./trees.vue?vue&type=script&lang=js"
export * from "./trees.vue?vue&type=script&lang=js"
import style0 from "./trees.vue?vue&type=style&index=0&id=038e1f52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038e1f52",
  null
  
)

export default component.exports